var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initParallaxTextReveal = /* @__PURE__ */ __name(($el, $refs) => {
  const state = window.Alpine.reactive({
    currentIndex: 0,
    blocks: [...$el.querySelectorAll("[data-scroll-spacing] > div")],
    steps: [...$refs.stepContainer.querySelectorAll("table")]
  });
  window.addEventListener("scroll", () => {
    let newIndex = state.currentIndex;
    state.steps.forEach((step, index) => {
      const rect = step.getBoundingClientRect();
      const inView = rect.top <= window.innerHeight * 0.5 && rect.bottom >= window.innerHeight * 0.5;
      if (inView) newIndex = index;
    });
    if (newIndex !== state.currentIndex) {
      state.currentIndex = newIndex;
    }
  });
  return {
    state
  };
}, "initParallaxTextReveal");
window._sections["initParallaxTextReveal"] = initParallaxTextReveal;
